"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxLogger = void 0;
_Object$defineProperty(exports, "buildUrl", {
  enumerable: true,
  get: function () {
    return _buildURL.default;
  }
});
exports.createConfig = exports.clearBlacklistedHeaders = exports.checkIfInstanceExists = void 0;
exports.createError = createError;
exports.retrieveInstance = exports.removeInstance = exports.prepareRequestUrl = exports.prepareRequestData = exports.prepareDataMapping = exports.instances = exports.createInstance = void 0;
exports.setupCsrfAndJwt = setupCsrfAndJwt;
exports.transformRequestData = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url-search-params"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _createError = _interopRequireDefault(require("axios/lib/core/createError"));
var _buildURL = _interopRequireDefault(require("axios/lib/helpers/buildURL"));
var _jsonFormData = _interopRequireDefault(require("json-form-data"));
var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));
var _ajax = require("./ajax");
var _config = require("./config");
var _devLogger = require("../dev-logger");
/**
 * Map of functions to dataTypes to be run in data preparation task for a match
 *
 * @type {Object}
 */
const prepareDataMapping = {
  [_config.SUPPORTED_PREPARED_DATA_TYPES.FORM_DATA]: data => {
    return (0, _jsonFormData.default)(data);
  },
  [_config.SUPPORTED_PREPARED_DATA_TYPES.JSON]: data => {
    return (0, _stringify.default)(data);
  },
  [_config.SUPPORTED_PREPARED_DATA_TYPES.URL_SEARCH_PARAMS]: data => {
    return new _urlSearchParams.default(data);
  }
};
exports.prepareDataMapping = prepareDataMapping;
const AjaxLogger = (0, _devLogger.createLogger)('Ajax Util');

/**
 * Checks if an existing instance of Ajax class exists in cache
 * @param {string} name Name of instance to be checked
 * @return {Ajax} Existing instance with the provided name
 */
exports.AjaxLogger = AjaxLogger;
const checkIfInstanceExists = name => {
  if ((0, _isUndefined2.default)(name) || (0, _isEmpty2.default)(name)) {
    throw new Error('No instance name was provided');
  }
  if ((0, _isUndefined2.default)(instances[name])) {
    return false;
  }
  return true;
};

/**
 * Function to clean up headers of blacklisted headers
 *
 * @type {object} config Object containing the desired configuration
 */
exports.checkIfInstanceExists = checkIfInstanceExists;
const clearBlacklistedHeaders = headers => {
  var _context;
  const blacklistedHeaders = ['X-CSRF-TOKEN'];
  if (!headers) {
    return {};
  }
  return (0, _reduce.default)(_context = (0, _keys.default)(headers)).call(_context, (newHeaders, header) => {
    if (!(0, _includes.default)(blacklistedHeaders).call(blacklistedHeaders, header)) {
      newHeaders[header] = headers[header];
    }
    return newHeaders;
  }, {});
};

/**
 * Function to create a configuration based off the baseConfig
 *
 * @type {object} config Object containing the desired configuration
 */
exports.clearBlacklistedHeaders = clearBlacklistedHeaders;
const createConfig = (config = {}) => {
  config.headers = clearBlacklistedHeaders(config.headers);
  return {
    ...(0, _cloneDeep2.default)(_config.baseConfig),
    transformRequest: [transformRequestData(config)],
    ...config
  };
};

/**
 * Creates a reusable error container that is consistent with Axios' error
 * @param {Object} msg The text of the error message or the response object for the request
 * @param {Object} [response] The response object for the request
 * @return {Error} A composed error object with additional properties added from Axios
 */
exports.createConfig = createConfig;
function createError(msg, response) {
  if ((0, _isEmpty2.default)(arguments)) {
    return;
  }
  if (arguments.length === 1 && !(0, _isString2.default)(msg)) {
    response = msg;
    msg = parseResponseError(response);
  }
  response = {
    config: {},
    request: {},
    ...response
  };
  return (0, _createError.default)(msg, response.config, null, response.request, response);
}

/**
 * Create a new instance of Ajax class to be used with supplied config as a base
 * @param {string} name Name of instance to be created
 * @param {object} config This is an optional configuration object to specify a base config for this instance
 * @return {Ajax} Newly created instance
 */
const createInstance = lib => {
  return (name, config = {}) => {
    if (checkIfInstanceExists(name)) {
      throw new Error(`Instance already exists with the name: '${name}'`);
    }
    instances[name] = new _ajax.Ajax(lib, name, config);
    return instances[name];
  };
};

/**
 * Object containing key/value pairs for created instances in this scope
 *
 * @type {object}
 */
exports.createInstance = createInstance;
const instances = {};

/**
 *
 * @param {Object} response The response object in which an error message should reside
 * @param {string} [defaultError = 'An unexpected error occurred'] A default error message if one is not found on the response
 */
exports.instances = instances;
const parseResponseError = response => {
  const defaultError = 'An unexpected error occurred';
  if (!response || (0, _isEmpty2.default)((0, _keys.default)(response))) {
    return defaultError;
  }
  const {
    data = {},
    headers = {}
  } = response;
  if ((0, _isEmpty2.default)((0, _keys.default)(data)) && (0, _isEmpty2.default)((0, _keys.default)(headers))) {
    return defaultError;
  }
  return data.error || data.errorMessage || headers['X-BambooHR-Error-Message'] || headers['X-BambooHR-Error-Messsage'] || defaultError;
};

/**
 * Takes the data and returns prepared data depending on dataType provided
 * @param {(array|Object|string)} data Data to be transformed and prepared
 * @param {string} dataType The type of data you wish to receive in return
 * @return {*} Data in the specified dataType, original data if unsuccessful
 */
const prepareRequestData = (data, dataType = '') => {
  const prepareFunction = prepareDataMapping[dataType];
  if ((0, _isFunction2.default)(prepareFunction)) {
    try {
      return prepareFunction(data);
    } catch (e) {
      return data;
    }
  }
  return data;
};
exports.prepareRequestData = prepareRequestData;
const prepareRequestUrl = config => {
  const {
    baseURL,
    url = '',
    urlParams
  } = config;
  if ((0, _isNil2.default)(urlParams)) {
    return config;
  }
  if (baseURL && !(0, _isEmpty2.default)(urlParams)) {
    try {
      config.baseURL = _pathToRegexp.default.compile(baseURL)(config.urlParams);
      config.url = _pathToRegexp.default.compile(url)(config.urlParams);
      config.urlParams = undefined;
    } catch (e) {
      return {
        urlError: e.message
      };
    }
  }
  return config;
};

/**
 * Deletes an existing instance of Ajax class
 * @param {string} name Name of instance to be deleted
 * @return {object} Object containing instances
 */
exports.prepareRequestUrl = prepareRequestUrl;
const removeInstance = name => {
  if (checkIfInstanceExists(name)) {
    delete instances[name];
  }
  return instances;
};

/**
 * Retrieves an existing instance of Ajax class
 * @param {string} name Name of instance to be retrieved
 * @return {Ajax} Existing instance with the provided name
 */
exports.removeInstance = removeInstance;
const retrieveInstance = name => {
  if (checkIfInstanceExists(name)) {
    return instances[name];
  }
  return false;
};

/**
 * Checks if Content-Type header is already set, and if not it will then apply it
 * @param {Object} headers HTTP headers to be sent to the server
 * @param {string} value value to be set to Content-Type header
 */
exports.retrieveInstance = retrieveInstance;
const setContentTypeIfUnset = (headers, value) => {
  if (!(0, _isUndefined2.default)(headers) && (0, _isUndefined2.default)(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
};

/**
 * Sets up the ajax instance provided to be able to add an interceptor to handle jwt tokens automatically
 * @param {Ajax} config HTTP request configuration object
 * @return {Function} Function to be called to set the JWT token and add the interceptor
 */
function setupCsrfAndJwt(ajax) {
  /**
   * Assigns an interceptor to the request to set the Authorization header with the JWT token if useJwt is set to true
   *
   * @param {Function} setJwtAuthHeaders Function to get the JWT token and set the Authorization header
   * @param {Function} getCsrfToken Function to retrieve the JWT token as a string
   */
  return function setupCsrfToken(setJwtAuthHeaders, getCsrfToken) {
    if (typeof getCsrfToken !== 'function') {
      getCsrfToken = function noopGetCsrfToken() {
        return '';
      };
    }
    if (typeof setJwtAuthHeaders !== 'function') {
      setJwtAuthHeaders = function noopSetJwtAuthHeaders() {
        return _promise.default.resolve();
      };
    }
    ajax.instance.interceptors.request.use(async function useJwtOrCsrf(config) {
      if (config.useJwt) {
        await setJwtAuthHeaders(config);
      }
      if (config.method === 'get' || config.headers.Authorization || config.useJwt) {
        return config;
      }
      if (!config.headers['X-CSRF-TOKEN']) {
        config.headers['X-CSRF-TOKEN'] = getCsrfToken();
      }
      return config;
    });
  };
}

/**
 * Transforms data input into supported output
 * @param {(object|FormData|string)} data Data to be sent to the server
 * @return {(object|FormData|string)} Formatted output in a supported type
 */
const transformRequestData = (config = {}) => {
  return (data, headers) => {
    if (!data) {
      return;
    }
    if (data instanceof FormData) {
      return data;
    }
    if (data instanceof _urlSearchParams.default) {
      setContentTypeIfUnset(headers, _config.CONTENT_TYPE_FORM_URLENCODED);
      return data.toString();
    }
    if (data.nodeType && data.nodeType === 1 && data.nodeName === 'FORM') {
      var _context2, _context3;
      setContentTypeIfUnset(headers, _config.CONTENT_TYPE_FORM_URLENCODED);
      return (0, _reduce.default)(_context2 = (0, _filter.default)(_context3 = (0, _from.default)(data)).call(_context3, el => {
        return el.name && !el.disabled && (el.checked || _config.rSelectTextarea.test(el.nodeName) || _config.rInput.test(el.type));
      })).call(_context2, (params, input) => {
        params.append(input.name, input.value.replace(_config.rCRLF, '\r\n'));
        return params;
      }, new _urlSearchParams.default()).toString();
    }
    if ((0, _isArray.default)(data) && config.serializeArray) {
      AjaxLogger.warn('Serialized arrays will be deprecated soon. Please update to use `serializeArray` setting set to true in either instance or request config');
      setContentTypeIfUnset(headers, _config.CONTENT_TYPE_FORM_URLENCODED);
      return (0, _reduce.default)(data).call(data, (params, item) => {
        params.append(item.name, item.value);
        return params;
      }, new _urlSearchParams.default()).toString();
    }
    if ((0, _isArray.default)(data) || (0, _isPlainObject2.default)(data)) {
      setContentTypeIfUnset(headers, _config.CONTENT_TYPE_JSON);
      return (0, _stringify.default)(data);
    }
    return data;
  };
};
exports.transformRequestData = transformRequestData;